export const teamMembers = [
  {
    title: "The ANVIYA Team",
    description:
      "Our multidisciplinary team combines scientific expertise, clinical knowledge, and operational excellence to deliver superior service across both research and diagnostic domains.",
    link: "/biospecimens-services",
  },
  {
    title: "Scientific Leadership",
    description:
      "PhD-level scientists with extensive experience in biobanking, specimen characterization, and translational research guide our biospecimen operations and ensure research-grade quality.",
    link: "/biospecimens-services",
  },
  {
    title: "Clinical Excellence & Technical Specialists",
    description:
      "Board-certified pathologists and laboratory physicians oversee diagnostic testing protocols, quality assurance, and result interpretation to guarantee clinical accuracy.",
    link: "/biospecimens-services",
  },
  {
    title: "Quality & Compliance",
    description:
      "Dedicated quality assurance professionals monitor all processes, maintain accreditation standards, and ensure regulatory compliance across research and clinical operations.",
    link: "/quality-compliance",
  },
];
